import { Component, OnInit, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { Observable, Subscription, catchError, debounceTime, distinctUntilChanged, map, of } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BoardApiService } from 'src/app/core/services/api/board-api/board-api.service';
import { BoardStateService } from 'src/app/core/services/data/board-state/board-state.service';
import { CommonUtilsService } from 'src/app/core/services/helper/common-utils.service';
import { ReferenceName } from '../../enum/reference-name.enum';
import { CommonDataService } from 'src/app/core/services/data/common-data/common-data.service';
import moment from 'moment';
import { TimelogCreatePopupComponent } from '../timelog-create-popup/timelog-create-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PermissionService } from 'src/app/core/services/permission/permission.service';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
    selector: 'ah-task-search',
    templateUrl: './task-search.component.html',
    styleUrls: ['./task-search.component.scss']
})
export class TaskSearchComponent implements OnInit {
    subscriptions: Subscription[] = [];
    @Output() selectedOption = new EventEmitter();
    
    taskList$: Observable<any>;
    taskSearchForm: FormGroup;
    activeTab: string = 'all';
    searchResult: boolean = true;
    timerState;
    currentResults: any[] = [];
    hasClientViewPermission: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private boardApi: BoardApiService,
        private elementRef: ElementRef,
        private boardState: BoardStateService,
        private commonUtility: CommonUtilsService,
        private commonState: CommonDataService,
        private dialog: MatDialog,
        private router: Router,
        private permissionService: PermissionService,
        private ngxPermissionsService: NgxPermissionsService,
    ) {}

    @HostListener('document:click', ['$event.target'])

    onClick(targetElement: any) {
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.resetSearchField();
        }
    }

    ngOnInit(): void {
        const permissionSub = this.ngxPermissionsService.permissions$.subscribe(permissions => {        
            this.hasClientViewPermission = !!(permissions && permissions['clientView']);
        });
        this.setSubscription(permissionSub);

        this.taskSearchForm = this.formBuilder.group({
            keyword: ['']
        });
        this.setupSearchSubscription();

        const timerState = this.boardState.select('currentTimerLog').subscribe(res => {
        this.timerState = res;
        });
        this.setSubscription(timerState);
    }

    navigateToTimeLog(id: string, routeParamsType: string='PROJECT') {
        // if(!id || !['PROJECT', 'TASK'].includes(routeParamsType) || this.projectId || (routeParamsType == 'PROJECT' && !this.hasPermission) || this.taskId){
        // return;
        // }
        this.router.navigate(['./dashboard/time-log/', { outlets: { 'ah-router-modal': ['viewLog', id] } }], {queryParams: { type: routeParamsType, fromSearch: 'true' }});
    }

    navigateToItem(item: any, event: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.selectedOption.emit(item);
        this.resetSearchField();
    }

    viewAllItems(event: Event) {
        if (event) {
            event.stopPropagation();
        }
    }

    // Task Start Timer
    initiateTask(task, taskStatus){        
        this.selectedOption.emit({task, taskStatus});
    }

    // Client Start Timer
    stopTimer() {
        const timeLogObs = this.commonUtility.stopTimer().subscribe((res) => {
        if (res) {
            this.commonUtility.getCurrentActiveTask();
        }
        });
        this.setSubscription(timeLogObs);
    }

    createTimelog( entityInfo, enityType) {
        if (!this.commonUtility.getCurrentActiveTimer()) {      
          
            this.startTime(entityInfo, enityType);
      } else {    
        
        if (!this.commonUtility.hasStorageTrack(ReferenceName.IsLogConfirmationDialogShow, true)) {
            const openCurrentLog = this.commonUtility.openCurrentLogClosePopup().subscribe((res) => {
                if (res) {          
                    this.openTimeLogDialog(this.commonUtility.getCurrentActiveTimer(), {entityInfo, enityType});
                }
            });
            this.setSubscription(openCurrentLog);
        } else {      
          this.openTimeLogDialog(this.commonUtility.getCurrentActiveTimer(), entityInfo);
        }
      }
    }

    startTime(entityInfo, enityType) {
        let payload = {
        time_format: 'SECONDS',
        timesheets: [
            {
                current_start_time: 1,
                entity_type: enityType,
                entity_id: entityInfo.id,
            },
        ],
        };

        const startTime = this.boardApi.createTimeLog(payload).subscribe(
        (res) => {
            this.commonUtility.startTimer(res.data.current_task);
            this.commonState.addTimeLog(true);
        },
        (error) => {
            // console.error(error);
        },
        );
        this.setSubscription(startTime);
    }


    openTimeLogDialog(currentTask, newTask) {
        let newPayload = { 
            'entity_id': newTask?.entityInfo?.id,
            'entity_type': newTask?.enityType,    
            'category': {
                'id': newTask?.category?.id
            },     
            'current_start_time': true
        }    
        
        currentTask.current_end_time = true;
        currentTask.end_date = moment(new Date()).format('YYYY-MM-DD');
        currentTask.end_time = moment(new Date()).format('HH:mm');
        currentTask.end_time_sec = moment(new Date()).format('HH:mm:ss');
        const dialogRef = this.dialog.open(TimelogCreatePopupComponent, {
            panelClass: 'ah-add-task',
            maxWidth: '500px',
            maxHeight: '700px',
            width: '100%',
            disableClose: true,
            autoFocus: false,
            data: {
                payload: currentTask,
                newTask: newPayload,
            }
        });
            const timelog = dialogRef.afterClosed().subscribe((value) => {
            if (value) {
                this.boardState.clearTimerLog();
                this.commonUtility.getCurrentActiveTask();
            }
        });
        this.setSubscription(timelog);
    }

    setupSearchSubscription(): void {
        const searchSubscription = this.taskSearchForm.get('keyword').valueChanges
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((val) => {
                if (val && val.length >= 3) {
                    this.taskList$ = this.filterTask(val);
                } else {
                    this.taskList$ = of({ loading: false, value: [] });
                    this.searchResult = true;
                }
            });
        
        this.subscriptions.push(searchSubscription);
    }

    transformToTableItem(item: any): any {
        const isProject = item.entity_type === 'project';
        const isClient = item.entity_type === 'client';
        const isTask = item.entity_type === 'task';
    
        let clientName = '-';
        if (isClient) {
            clientName = item.name;
        } else if (item.client_name) {
            clientName = item.client_name;
        } else if (item.client && item.client.name) {
            clientName = item.client.name;
        }
  
        let projectName = '-';
        if (isProject) {
            projectName = item.name;
        } else if (isClient) {
            projectName = '-';
        } else if (item.project_name) {
            projectName = item.project_name;
        } else if (item.project && item.project.name) {
            projectName = item.project.name;
        }
   
        let taskName = '-';
        if (isTask) {
            taskName = item.name;
        } else if (isProject) {
            taskName = '-';
        } else if (isClient) {
            taskName = '-';
        }
        
        let lastTracked = this.formatLastTracked(item.last_accessed_at || item.updated_at || item.created_at);
        
        return {
            id: item.id,
            clientName: clientName,
            projectName: projectName,
            taskName: taskName,
            lastTracked: lastTracked,
            entityType: item.entity_type,
            taskId: item.code || (isProject ? 'PROJ' : isClient ? 'CLNT' : 'TASK'),
            originalData: item
        };
    }
    
    formatLastTracked(dateString: string): string {
        if (!dateString) {    
            return 'Recently';
        }
        
        try {
            const lastDate = new Date(dateString);
            const now = new Date();
            const diffMs = now.getTime() - lastDate.getTime();
            const diffMins = Math.floor(diffMs / (1000 * 60));
            const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
            const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            
            if (diffMins < 1) {
                return 'Just now';
            } else if (diffMins < 60) {
                return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
            } else if (diffHours < 24) {
                return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
            } else if (diffDays < 7) {
                return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
            } else if (diffDays < 30) {
                const weeks = Math.floor(diffDays / 7);
                return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
            } else {
                const months = Math.floor(diffDays / 30);
                return `${months} month${months > 1 ? 's' : ''} ago`;
            }
        } catch (error) {
            console.error("Error formatting date:", dateString, error);
            return 'Recently';
        }
    }    

    filterTask(val: any): Observable<any> {
        if (val == '') {
            this.currentResults = [];
            return of({ loading: false, value: [] });
        }
        
        const searchValue = typeof val == 'object' ? val.title : val;
        
        const payload = {
            filters: {
                keyword: searchValue,
                global_search: true
            }
        };
        
        return this.boardApi.searchList(payload).pipe(
            map((response: any) => {
                
                let items = [];
                
                if (response && response.data && response.data.results) {
                    items = response.data.results;           
                } else if (response && response.results) {
                    items = response.results;
                }
                
                const transformedItems = items.map(item => {                
                    return this.transformToTableItem(item);
                });               
         
                this.currentResults = transformedItems;           
                
                this.searchResult = transformedItems.length > 0;
                
                return {
                    loading: false,
                    value: transformedItems
                };
            }),
            catchError(error => {          
                this.currentResults = [];
                this.searchResult = false;
                return of({ loading: false, value: [] });
            })
        );
    }

    safeGetCount(type: string): number {
        const items = this.currentResults || [];
        
        if (type === 'all') {
            return items.length;
        }
        
        const getEntityType = (item: any): string => {
            return item?.entityType || item?.entity_type;
        };
        
        return items.filter(item => getEntityType(item) === type).length;
    }

    getFilteredItems(): any[] {
        try {
            const items = this.currentResults || [];    
            
            if (!items || items.length === 0) {
                return [];
            }
            
            const getEntityType = (item: any): string => {
                return item?.entityType || item?.entity_type;
            };
            
            let filtered = [];
            switch(this.activeTab) {
                case 'clients':
                    // Only show clients if has permission
                    if (this.hasClientViewPermission) {
                        filtered = items.filter(item => getEntityType(item) === 'client');
                    } else {
                        filtered = [];
                    }
                    break;
                case 'projects':
                    filtered = items.filter(item => getEntityType(item) === 'project');
                    break;
                case 'tasks':
                    filtered = items.filter(item => getEntityType(item) === 'task');
                    break;
                default:
                    filtered = items;
            }
    
            return filtered;
        } catch (error) {       
            return [];
        }
    }

    getCountByType(type: string): number {
        return this.safeGetCount(type);
    }

    setActiveTab(tab: string) {
        this.activeTab = tab;
    }

    get f() {
        return this.taskSearchForm.controls;
    }

    resetSearch() {
        this.resetSearchField();
    }

    resetSearchField() {
        this.taskSearchForm.get('keyword').setValue('');
        this.activeTab = 'all';
    }

    setSubscription(request: Subscription): void {
        this.subscriptions.push(request);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}